import { supabase } from '../lib/supabase';

export const authService = {
  /**
   * Sign in with email and password
   */
  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;
    return data;
  },

  /**
   * Sign up a new user with profile data
   */
  async signUp(email, password, fullName, role = 'rnr_personnel', location = '', phone = '') {
    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
          role: role,
          location: location,
          phone: phone,
          avatar_url: '',
        },
      },
    });

    if (error) throw error;
    return data;
  },

  /**
   * Sign out the current user
   */
  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  /**
   * Send password reset email
   */
  async resetPassword(email) {
    const { error } = await supabase?.auth?.resetPasswordForEmail(email, {
      redirectTo: `${window.location?.origin}/reset-password`,
    });

    if (error) throw error;
  },

  /**
   * Update password
   */
  async updatePassword(newPassword) {
    const { error } = await supabase?.auth?.updateUser({
      password: newPassword,
    });

    if (error) throw error;
  },

  /**
   * Get current user
   */
  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  /**
   * Get user profile
   */
  async getUserProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();

    if (error) throw error;
    
    // Convert snake_case to camelCase
    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      role: data?.role,
      status: data?.status,
      location: data?.location,
      avatarUrl: data?.avatar_url,
      phone: data?.phone,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
    };
  },

  /**
   * Update user profile
   */
  async updateUserProfile(userId, updates) {
    // Convert camelCase to snake_case for database
    const dbUpdates = {};
    if (updates?.fullName !== undefined) dbUpdates.full_name = updates?.fullName;
    if (updates?.location !== undefined) dbUpdates.location = updates?.location;
    if (updates?.phone !== undefined) dbUpdates.phone = updates?.phone;
    if (updates?.avatarUrl !== undefined) dbUpdates.avatar_url = updates?.avatarUrl;

    const { data, error } = await supabase?.from('user_profiles')?.update(dbUpdates)?.eq('id', userId)?.select()?.single();

    if (error) throw error;

    // Convert snake_case to camelCase
    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      role: data?.role,
      status: data?.status,
      location: data?.location,
      avatarUrl: data?.avatar_url,
      phone: data?.phone,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
    };
  },
};